import baseFindIndex from "./component-library440.mjs";
import baseIsNaN from "./component-library441.mjs";
import strictIndexOf from "./component-library442.mjs";
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
export {
  baseIndexOf as default
};
